export default "__VITE_ASSET__CubxlJpX__"